// #region методы pager
var drawfirst = function (data1) {
    $('.treatmet-pager').PagerPlugins({
        totalRows: data1.count,
        sendMethodCaption: "./ASPWebDataServise.asmx/GetListOrg",
        sendMethodObj: Reestr.setSearchParameter()
    },
        {
            show: function (data1) {
                draw(data1);
            }
        }
    );
    // draw(data1);
};

var draw = function (resp) {
    Reestr.setOrgList(resp);
};
// #endregion

// основной класс
var Reestr = (function () {
    const URL = './ASPWebDataServise.asmx/';
    let core = require('./core_last.js'); // TO DO: как только дойдут руки переписать нафиг весь core

    //To CORE!!!!
    var _fetchAsync = async (url, caption, body = null) => {
        let jb = {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        };

        if (body !== null) {
            let sendJSON = JSON.stringify(body);
            jb.body = "{inputsParam:'" + sendJSON + "'}";

        }
        const promise = await fetch(url + caption, jb);
        return await promise.json();
    };

    var _setCaptionColumn = (caption, sort, reg) => {
        var txt = '';
        if (sort == null && reg == null)
            txt = caption;
        else {
            txt += '<div class="d-flex flex-column">';
            txt += '    <div class="p-2">' + caption + '</div>';
            txt += '    <div class="ml-2 sub-column-caption">' + sort + '</div>';
            txt += '    <div class="ml-2 sub-column-caption">' + reg + '</div>';
            txt += '</div>';
        }
        return txt;
    }

    // устанавливает параметры с формы
    var _setSearchParameter = () => {
        let searchArr = $('#collapse_search_panel__form').serializeArray(),
            searchObj = {},
            searchKey = [];

        searchArr.forEach((item) => {
            if (!searchKey.includes(item.name) && item.value != '')
                searchKey.push(item.name)
        });

        searchKey.forEach((item) => {

            let A = searchArr.filter(x => x.name === item);
            if (A.length > 1) {
                let arrTmp = A.map(a => a.value);
                searchObj[item] = arrTmp;
            }
            else {
                let val = A[0].value;
                searchObj[item] = val;
            }
        });

        return searchObj;
    };

    // отрисовка pager вызов отрисовки данных
    var _setDataListOrg = response => {
        let a = JSON.parse(response.d);
        if ($.isEmptyObject(a) || a.HasError || a.count == 0) {
            $('.greed-region').hide();
            $('.message-region').show();

            core.stoptLoadingAnimation();

            return false;
        }

        $('.message-region').hide();
        $('.greed-region').show();

        _setOrgList(a);
        drawfirst(a);

        core.stoptLoadingAnimation();
    };

    //отрисовка всех данных после запроса
    var _setOrgList = (response) => {
        let obj = response.listOrg,
            count = response.count,
            sessionCount = sessionStorage.getItem('count'),
            txt = '';

        if (!sessionCount) {
            sessionStorage.setItem('count', count);
            $('#totalLbl').text('Поставщиков услуг в реестре: ' + count);
        }
        else if (sessionCount > count)
            $('#totalLbl').text('Поставщиков услуг в реестре: ' + sessionCount + '/ по фильтру:  ' + count);
        else if (sessionCount == count)
            $('#totalLbl').text('Поставщиков услуг в реестре: ' + count);
        else
            $('#totalLbl').text('Поставщиков услуг в реестре: ' + count);

        var objTbl = {};
        objTbl.columns = [
            { "name": "index", "title": "#", "style": { "text-align": "center" } },
            { "name": "name", "title": "Поставщик" },
            { "name": "tel", "title": "Контактный телефон", "breakpoints": "xs" },
            { "name": "addr", "title": "Адрес", "breakpoints": "xs" },
            { "name": "mail", "title": "Электронная почта", "breakpoints": "xs" },
            { "name": "id", "visible": false },
            { "name": "map", "title": "", "breakpoints": "xs", "style": { "text-align": "center" } },
        ];
        objTbl.rows = [];

        obj.forEach((item, index) => {
            let tObj = {
                index: item.num,
                name: item.name == null ? '' : _setCaptionColumn(item.name, item.sortvid, item.reg),
                tel: item.tel == null ? 'не указан' : item.tel,
                addr: item.addr == null ? 'не указан' : item.addr,
                mail: item.email == null ? 'не указан' : '<a class="a_t" href="mailto:' + item.email + '" rel="noopener noreferrer">' + item.email + '</a>',
                id: item.id,
                map: (item.addr.indexOf('не заполнен') == -1 ? '<a class="base_link" href="#" data-toggle="tooltip" data-html="true" title="Посмотреть на карте" rel="noopener noreferrer"> <span class="glyphicon glyphicon-map-marker" aria-hidden="true"></span></a> ' : '')
            };
            objTbl.rows.push(tObj);
        });
        $('.res_grid_table').footable(objTbl);

        let pagecount = Math.ceil(count / response.listOrg.length);
        $('#allPage').text('Всего страниц: ' + pagecount);
    };

    // #region EventFunction

    // ткнуть на кнопку поиска
    var _searchFunction = (e) => {
        core.startLoadingAnimation();
        let searchObj = _setSearchParameter(),
            promise = _fetchAsync(URL, 'GetListOrg', searchObj).then(response => _setDataListOrg(response), err => console.error(`ошибка при получении данных: ${err}`));
    };

    // ткнуть на кнопку очистить
    var _clearFunction = (e) => {
        core.startLoadingAnimation();
        core.clear('collapse_search_panel__form');
        $('#org-yes').prop('checked', false);
        $('#org-no').prop('checked', false);

        let promise = _fetchAsync(URL, 'GetListOrg', {}).then(response => _setDataListOrg(response), err => console.error(`ошибка при получении данных: ${err}`));
    };

    // ткнуть по строке таблицы
    var _rowClick = (e) => {
        e.preventDefault();
        var row = FooTable.getRow(e.currentTarget),
            value = row.val().id;
        if ($(event.target).hasClass('glyphicon'))
            window.location = './maps_last.html?orgId=' + value;
        else
            window.location = './org_last.html?id=' + value
    };

    // ткнуть "Является уполномоченной организацией"
    var _cntrlClick = (e) => {
        if ($('#' + e.currentTarget.id).is(':checked')) {
            $('#org-yes').prop('checked', false);
            $('#org-no').prop('checked', false);
            $('#' + e.currentTarget.id).prop('checked', true);

            if (e.currentTarget.id === 'org-yes')
                $('#isauthorized').val('1');
            else
                if (e.currentTarget.id === 'org-no')
                    $('#isauthorized').val('0');
        }
        else
            $('#isauthorized').val('');
    };
    // #endregion

    // точка входа 
    var init = () => {
        core.startLoadingAnimation();
        core.setControlforReestrListform(); // рисуем контролы поиска
        let promise = _fetchAsync(URL, 'GetListOrg', {}).then(response => _setDataListOrg(response), err => console.error(`ошибка при получении данных: ${err}`));
    };

    return {
        // public методы
        init: init,
        searchFunction: _searchFunction,
        clearFunction: _clearFunction,
        setOrgList: _setOrgList,
        setSearchParameter: _setSearchParameter,
        rowClick: _rowClick,
        cntrlClick: _cntrlClick
    };
}());

(function main() {
    $("body").fadeIn(2000);

    $('#search--btn').on('click', Reestr.searchFunction);
    $('#clear--btn').on('click', Reestr.clearFunction);
    $('.res_grid_table').on('click', 'tr', Reestr.rowClick);
    $('.custom-control-input').on('click', Reestr.cntrlClick);
    Reestr.init();
}());